import React from 'react';

import { Chip, Copy, Mark } from './MatureVideoChip.styles';

export interface MatureVideoChipProps {
  className?: string;
}

/**
 * Why a video ad can't be generated: the brand's primary art style is mature, which the video models refuse. A pill
 * with the same red "18+" mark as the art styles listing, spanning the row it sits in (the generate controls).
 */
export const MatureVideoChip = ({ className }: MatureVideoChipProps): React.ReactElement => (
  <Chip className={className}>
    <Mark text="18+" tag="span" />
    <Copy text="Mature content isn't compatible with video generation." tag="span" />
  </Chip>
);

export default MatureVideoChip;
